export default class RelatedStory {
	constructor(elm) {
		this.elm = elm;
		this.breakpoint = window.matchMedia('(max-width:767px)');
		this.timer = null;

		this.init();
	}

	init() {
		document.fonts.ready.then(() => {

			if (!'IntersectionObserver' in window){
				return;
			}

			this.boundHandleIntersection = this.handleIntersection.bind(this);
			this.observer = new IntersectionObserver(this.boundHandleIntersection, {
				rootMargin: '-50% 0px 0px 0px',
			});
			this.observer.observe(this.elm);
		});
	}

	handleIntersection(entries) {
		if (this.breakpoint.matches !== true) {
			this.deActivate();
			return;
		}

		entries.forEach(entry => {
			const ratio = entry.intersectionRatio;

			if (ratio > 0) {
				this.activate(entry.target);
			}

			if (ratio <= 0 || ratio > 1) {
				this.deActivate(entry.target);
			}
		});
	}

	activate(entry = null) {
		if (!entry) {
			entry = this.elm;
		}

		if (typeof this.timeoutID === 'number') {
			return;
		}

		this.timer = setTimeout(() => {
			entry.classList.add('c-related-story--visible');
		}, 1000);
	}

	deActivate(entry = null) {
		if (!entry) {
			entry = this.elm;
		}

		this.clearTimer();

		entry.classList.remove('c-related-story--visible');
	}

	clearTimer() {
		if (typeof this.timeoutID !== 'number') {
			return;
		}

		clearTimeout(this.timer);
		this.timer = null;
	}
}
